// extracted by mini-css-extract-plugin
module.exports = {"become":"styles_become__1MAOD"};